export default {"src":"/_next/static/media/extra-revisions.b3ba592d.svg","height":25,"width":23,"blurWidth":0,"blurHeight":0};